// API PATH
// export const apiPath = "https://cifssapi.sec.gov.ph"; // PROD
// export const apiPath = "https://cifss.api.uat.comclark.tech"; // UAT
export const apiPath = "https://cifss.api.dev.comclark.tech"; // DEV
// export const apiPath = "https://api.fortisph.space/gateway"
// export const apiPath = "http://121.58.254.209"; // V2
